import React, { Component } from 'react';
import { CommonlyHead } from '../common/headnav';
import { Tabs, WhiteSpace } from 'antd-mobile';
import { NewItems } from '../new/item';
import '../new/style.less'

const tabs = [
    { title: '健康知识' },
    { title: '新闻资讯' },
];
export default class NewList extends Component {
    render() {

        return (<div className="new">
            <CommonlyHead barname="推荐资讯" />
            <Tabs tabs={tabs}
                initialPage={0}
                onChange={(tab, index) => { }}
                onTabClick={(tab, index) => { }}
            >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#fff',paddingTop:'40px' }}>
                    <NewItems />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#fff',paddingTop:'40px' }}>
                <NewItems />
      </div>

            </Tabs>

            <WhiteSpace />

        </div>);
    }
}